import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {
    receivedShoutouts: null,
    givenShoutouts: null,
  },
};

const shoutoutsSlice = createSlice({
  name: "shoutouts",
  initialState,
  reducers: {
    updateShoutoutsData: (state, action) => {
      state.data = { ...state.data, ...action.payload };
    },
  },
});

export const { updateShoutoutsData } = shoutoutsSlice.actions;

export default shoutoutsSlice.reducer;
